import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectBcnPageComponent } from './components/select-bcn-page/select-bcn-page.component';
import {ConsentFormPageComponent} from "./components/consent-form-page/consent-form-page.component";
import {AuthGuard} from "./core/guards/auth.guard";
import {ErrorPageComponent} from "./components/error-page/error-page.component";
import {EntitlementsErrorPageComponent} from "./components/entitlements-error-page/entitlements-error-page.component";

const routes: Routes = [
  {path:"form", redirectTo: "form", pathMatch: 'full'},
  {path: "error", component: ErrorPageComponent},
  {path: "entitlements-error", component: EntitlementsErrorPageComponent},
  {path: "remote", component: SelectBcnPageComponent},
  {path: "remote/:id", component: SelectBcnPageComponent},
  {path: "**", redirectTo: "remote"},
  {path: "form", canActivate: [AuthGuard], component: ConsentFormPageComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
